import { handleKeyDown } from "_services";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { UserContext } from "context";
import { addTotalFrieght, editTotalFrieght } from "features";
import { errorSchema, utils } from "helper";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices/StorageServices";

const AddTotalFreightModal = (props) => {
  const { editData } = props;

  const intialTotal = {
    trip_id: props?.tripId,
    freight_type: 6,
    qty: "",
    rate: "",
    amount: "",
    tds_diduction: 0,
  };
  const dispatch = useDispatch();
  const { masterData } = useContext(UserContext);
  const [tdsChecked, setTdsChecked] = useState(false);
  const [tdsList, setTDsList] = useState([]);
  const [formTotal, setFormTotal] = useState(intialTotal);
  const [formTotalName, setFormTotalName] = useState(intialTotal);
  const [formError, setFormError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [tdsAmmount, setTdsAmmount] = useState(0);

  useEffect(() => {
    if (masterData) {
      const Tds = masterData.tds_section_list?.map((item) => {
        return { label: item?.name, value: item?.id };
      });
      const lrFreight = masterData?.contract_rate_type_list?.map((item) => {
        return { label: item?.name, value: item?.id };
      });
      setTDsList(Tds);
      setFreightTypeList(lrFreight);
      setFormTotal({ ...formTotal, trip_id: props?.tripId });
    }
  }, [masterData]);

  useEffect(() => {
    if (props?.totalFreightDetails || editData) {
      setFormTotal({
        ...formTotal,
        amount: editData?.total_freight
          ? editData?.total_freight
          : props?.totalFreightDetails?.balance,
        rate: editData?.rate ? editData?.rate : props?.totalFreightDetails?.rate,
        qty: editData?.qty ? editData?.qty : props?.totalFreightDetails?.qty,
        freight_type: editData?.freight_type
          ? editData?.freight_type
          : props?.totalFreightDetails?.freight_type,
        tds_diduction: editData?.tds_deduction
          ? editData?.tds_deduction
          : props?.totalFreightDetails?.tds_deduction,
      });
      if (
        editData
          ? editData?.tds_deduction
          : props?.totalFreightDetails?.tds_deduction > 0
      ) {
        setTdsChecked(true);
      }
    }
  }, [props?.totalFreightDetails, editData]);

  useEffect(() => {
    setFormTotal((prev) => ({
      ...prev,
      tds_diduction: tdsChecked ? 1 : 0,
      trip_id: props?.tripId,
    }));

    setFormTotalName((prev) => ({
      ...prev,
      tds_diduction: tdsChecked
        ? { label: "1%", value: "1" }
        : { label: "", value: "" },
    }));
  }, [tdsChecked, props?.tripId]); // Added `props?.tripId` to avoid stale closure

  useEffect(() => {
    if (formTotal?.freight_type !== 6) {
      setFormTotal((prev) => ({
        ...prev,
        amount: Number(prev?.qty) * Number(prev?.rate),
      }));
    }
  }, [formTotal.rate, formTotal.qty]); // Removed unnecessary optional chaining

  useEffect(() => {
    setFormTotal((prev) => ({
      ...prev,
      rate: prev.freight_type === 6 ? "" : prev.rate || "",
      qty: prev.freight_type === 6 ? "" : prev.qty || "",

    }));
  }, [formTotal.freight_type]); // Added dependency to avoid stale closure

  useEffect(() => {
    setTdsAmmount((formTotal?.amount * formTotal?.tds_diduction) / 100 || 0);
  }, [formTotal]);

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...formTotal,
      [name]: value,
    };
    setFormTotal(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj },
        errorSchema.addTotalFreigthSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitTotal = async () => {
    const validationResult = await utils.checkFormError(
      { ...formTotal },
      errorSchema.addTotalFreigthSchema
    );
    const payload = {
      company_id: StorageService?.getCompanyId(),
      trip_id: props?.tripId,
      freight_type: formTotal?.freight_type,
      qty: Number(formTotal?.qty),
      rate: Number(formTotal?.rate),
      amount: Number(formTotal?.amount),
      tds_diduction: formTotal?.tds_diduction ? formTotal?.tds_diduction : 0,
    };
    try {
      if (validationResult === true) {
        setIsLoading(true);
        const isNewFreight = props?.totalFreightDetails || editData;
        const action = !isNewFreight ? addTotalFrieght : editTotalFrieght;
        const res = await dispatch(action(payload));
        if (res?.payload?.responseCode === 200) {
          setIsLoading(false);
          handleCloseTotal();
          props.callbackTotal();
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        setFormError(validationResult);
      }
    } catch {
      setIsLoading(false);
    }
  };

  const allClear = () => {
    setFormTotal({ ...intialTotal });
  };
  const handleCloseTotal = () => {
    props?.closeModal();
    allClear();
  };

  const modifyProps = {
    ...props,
    onSubmit: onSubmitTotal,
    isLoading: isLoading,
    disabled:  isLoading
  };
  return (
    <div>
      <CommonModal {...modifyProps}>
        <div className="addTotalFreight_body">
          <div className="_qntSelector">
            <CustomSelect
              label="Freight Type"
              options={freightTypeList?.length ? freightTypeList : []}
              onSelect={(data) => handleOnChange("freight_type", data?.value)}
              value={freightTypeList?.find(
                (i) => i?.value === formTotal?.freight_type
              )}
              focus={!!formError?.freight_type}
              error={formError.freight_type}
            />
          </div>

          {formTotal?.freight_type !== 6 ? (
            <div className="_clmsFlex">
              <div className="clmDual_fx">
                <CommonInput
                  type="text"
                  name="qty"
                  value={formTotal.qty}
                  // onChange={({ target: { name, value } }) => {
                  //   // Only allow: empty, whole numbers, or numbers with up to 2 decimals
                  //   const regex = /^(\d+(\.\d{0,2})?)?$/;
                  //   if (regex.test(value)) {
                  //     handleOnChange(name, value);
                  //   }
                  // }}
                  onChange={({ target: { name, value } }) => {
                    if (/^0[0-9]/.test(value)) {
                      value = value.replace(/^0+/, ''); // "01" → "1"
                    }

                    // Allow "0." for decimals but not "0x" where x is digit
                    if (value === "0") {
                      handleOnChange(name, value);
                      return;
                    }
                    handleOnChange(name, value)
                  }}
                  label={
                    freightTypeList.length
                      ? freightTypeList?.find(
                        (i) => i?.value === formTotal?.freight_type
                      ).label
                      : "Qty"
                  }
                  maxLength={12}
                  onKeyDown={handleKeyDown}
                  focus={!!formError?.qty}
                  error={formError.qty}
                />
              </div>
              <div className="clmDual_fx">
                <CommonInput
                  type="text"
                  label="Rate"
                  name="rate"
                  maxLength={12}
                  value={formTotal.rate}
                  // onChange={({ target: { name, value } }) => {
                  //   const regex = /^(\d+(\.\d{0,2})?)?$/;
                  //   if (regex.test(value)) {
                  //     handleOnChange(name, value);
                  //   }
                  // }}
                  onChange={({ target: { name, value } }) => {
                    if (/^0[0-9]/.test(value)) {
                      value = value.replace(/^0+/, ''); // "01" → "1"
                    }

                    // Allow "0." for decimals but not "0x" where x is digit
                    if (value === "0") {
                      handleOnChange(name, value);
                      return;
                    }
                    handleOnChange(name, value)
                  }}
                  onKeyDown={handleKeyDown}
                  focus={!!formError?.rate}
                  error={formError.rate}
                />
              </div>
            </div>
          ) : (
            <div className="">
              <CommonInput
                type="text"
                // onChange={({ target: { name, value } }) => {
                //     const regex = /^(\d+(\.\d{0,2})?)?$/;
                //     if (regex.test(value)) {
                //       handleOnChange(name, value);
                //     }
                //   }}
                  onChange={({ target: { name, value } }) => {
                    if (/^0[0-9]/.test(value)) {
                      value = value.replace(/^0+/, ''); // "01" → "1"
                    }

                    // Allow "0." for decimals but not "0x" where x is digit
                    if (value === "0") {
                      handleOnChange(name, value);
                      return;
                    }
                    handleOnChange(name, value)
                  }}
                label={
                  freightTypeList.length
                    ? freightTypeList?.find(
                      (i) => i?.value === formTotal?.freight_type
                    ).label
                    : "Qty"
                }
                maxLength={20}
                onKeyDown={handleKeyDown}
                placeholder="Enter Freight"
                value={formTotal?.amount}
                name="amount"

                focus={!!formError?.amount}
                error={formError.amount}
              />
            </div>
          )}

          <div className="_amtBaar">
            <p>Amount</p>
            {/* <p>{`₹ ${formTotal?.amount ?  (formTotal?.amount)?.toFixed(2) : 0.00}`}</p> */}
            {/* <p>{`₹ ${(formTotal?.amount || 0).toFixed(2)}`}</p> */}
            <p>
              {/* {`₹ ${(formTotal?.amount || 0)}`}₹{" "} */}
                  {Number(formTotal?.amount || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</p>
          </div>

          {/* <CommonInput
            type="text"
            label="Amount (₹)"
            placeholder="Enter Amount"
            onKeyDown={handleKeyDown}
            value={formTotal?.amount}
            onChange={(e) => handleOnChange("amount", e.target.value)}
          />
          {formError.amount  && <small className="text-danger">{formError.amount}</small>} */}

          {/* <div className="form-check form-switch">
            <input
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckDefault"
            checked={tdsChecked}
            onChange={(e) => setTdsChecked(e.target.checked)}
            />
            <label className="form-check-label" for="flexSwitchCheckDefault">
            {tdsChecked ? "Yes" : "No"}
            </label>
            </div> */}

          <div>
            <span className="_tdsLabel">TDS Deduction</span>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                checked={tdsChecked}
                onChange={(e) => setTdsChecked(e.target.checked)}
              />
              <label className="form-check-label" for="flexSwitchCheckDefault">
                {tdsChecked ? "Yes" : "No"}
              </label>
            </div>
            {tdsChecked && (
              <CustomSelect
                label="TDS Deduction %"
                // value={formTotalName?.tds_diduction }
                value={
                  formTotal?.tds_diduction !== 0
                    ? tdsList?.find(
                      (i) => i?.value === formTotal?.tds_diduction
                    )
                    : { label: "", value: "" }
                }
                options={tdsList}
                disabled={!tdsChecked}
                onSelect={(data) => {
                  handleOnChange("tds_diduction", data?.value);
                  setFormTotalName({ ...formTotalName, tds_diduction: data });
                }}
                focus={!!formError?.tds_diduction}
                error={formError.tds_diduction}
              />
            )}

            {editData && <div className="_amtBaar">
              <p>TDS Amount</p>
              <p>
                {/* {`₹ ${(tdsAmmount || 0).toFixed(2)}`}  ₹{" "} */}
                  {Number(tdsAmmount || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</p>
            </div>}
          </div>
        </div>
      </CommonModal>
    </div>
  );
};

export default AddTotalFreightModal;
